'use strict'

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./formik.cjs.production.js');
} else {
  module.exports = require('./formik.cjs.development.js');
}


//////////////////
// WEBPACK FOOTER
// ./~/formik/dist/index.js
// module id = 72
// module chunks = 70144966829960 73875541826398 169315112914517